import { T } from "@freightsimple/ui-core/Typography/T";
import { knownInstitutionNumbers } from "./knownInstitutionNumbers";
import {
  IconsLogoBox,
  type IconsLogoAlign,
} from "./CustomComponents/IconsLogoBox";
import { IconsLogoImage } from "./CustomComponents/IconsLogoImage";

type AlignOptions = IconsLogoAlign;

interface BankLogoProps {
  institutionNumber: string;
  stripeBankName: string;
  align?: AlignOptions | undefined;
}

function displayNameForInstitutionNumber(
  institutionNumber: string,
  stripeBankName: string,
): string {
  if (institutionNumber === "001") {
    return "BMO";
  }

  if (institutionNumber === "002") {
    return "Scotiabank";
  }

  if (institutionNumber === "003") {
    return "RBC";
  }

  if (institutionNumber === "004") {
    return "TD";
  }

  if (institutionNumber === "006") {
    return "National Bank";
  }

  if (institutionNumber === "010") {
    return "CIBC";
  }

  if (institutionNumber === "016") {
    return "HSBC";
  }

  if (institutionNumber === "030") {
    return "CWB";
  }

  return stripeBankName;
}

export function BankLogo(props: BankLogoProps) {
  const { institutionNumber, stripeBankName } = props;

  const displayName = displayNameForInstitutionNumber(
    institutionNumber,
    stripeBankName,
  );

  if (knownInstitutionNumbers.includes(institutionNumber)) {
    return (
      <IconsLogoBox align={props.align || "left"} height={35}>
        <IconsLogoImage
          maxHeight={250}
          maxWidth={100}
          alt={displayName}
          src={`/images/bankLogos/${institutionNumber}.png`}
        />
      </IconsLogoBox>
    );
  } else {
    return (
      <IconsLogoBox padded labelGap>
        <IconsLogoImage
          src={`/images/credit-card-brands/generic-bank.png`}
          width={24}
          height={24}
          alt="Bank logo"
        />
        <T size="xl" weight="medium">
          {displayName}
        </T>
      </IconsLogoBox>
    );
  }
}
